/*
 * Features
 *   1. (Should) render on every page
 *   2. Sets the og:url meta tag automatically
 *   3. Deindexes the page, if the store says to do so
 */

import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'

import * as router from '../../store/router'
import * as site from '../../store/site'

import Head from './Head'

const AlwaysHead = ({canonicalHref, pathname}) => (
  <Head canonicalHref={canonicalHref} url={`${window.location.origin}${pathname}`} />
)

AlwaysHead.propTypes = {
  canonicalHref: PropTypes.string,
  pathname: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  canonicalHref: site.canonicalHref(state),
  pathname: router.pathname(state),
})

export default connect(mapStateToProps)(AlwaysHead)
